import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Wrench } from "lucide-react";

const Maintenance = () => {
  const { t } = useLang();
  return (
    <div
      data-testid="maintenance-page"
      className="min-h-screen flex flex-col items-center justify-center bg-[#F5F2ED] px-6 text-center"
    >
      <div className="max-w-2xl">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#D4AF37]/15 text-[#D4AF37] mb-8">
          <Wrench size={36} />
        </div>
        <p className="overline mb-4 text-[#D4AF37]">Amazypet</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2C1E16] mb-6 leading-tight">
          {t("maintenance.title")}
        </h1>
        <p className="text-base sm:text-lg text-[#736B66] mb-10">
          {t("maintenance.message")}
        </p>
        <Link
          to="/login"
          data-testid="maintenance-admin-login"
          className="luxury-btn-outline inline-flex items-center gap-2"
        >
          {t("maintenance.adminLogin")} →
        </Link>
      </div>
    </div>
  );
};

export default Maintenance;
